import * as React from 'react';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

export interface CommentSuccessComponentProps {
  modalRef?: Modal;
}

const CommentSuccessComponent: React.StatelessComponent<CommentSuccessComponentProps> =
  (props: CommentSuccessComponentProps) => {

    return (
      <div className="modal-content">
        <div className="modal-header">
          <p className="text-right">
        <span
          className="close-med pointer"
          onClick={() => props.modalRef!.modal('hide')}
        />
            <span className="corrected-circle"/>
            <div className="gap-20"/>
          </p>
          <h4 className="text-center">
            <strong>
              Estamos revisando tu comentario
            </strong>
          </h4>
        </div>

        <div className="modal-body">

          <div className="text-center">
            Tu comentario se ha enviado correctamente y lo estamos revisando, podrás ver tu comentario cuando sea
            aceptado.
          </div>
          <div className="gap-30"/>

        </div>
      </div>
    );
  };

export default CommentSuccessComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/CommentSuccess.component.tsx